<template>
  <article class="">
    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Búsqueda de Usuario
        </p>
      </div>
    </div>
    <div class="table_card__body">
      <v-flex xs12 row>
        <v-layout row wrap >
          <v-flex xs6 >
            <input
              v-model="searching_data"
              placeholder="Ingrese el documento o correo electrónico"
              required
              class="input_solid"
              style="width: 98% !important"
            >
            <img
              src="@/assets/img/icons/search-icon.svg"
              class="button_search"
              style="margin-left: -55px"
            >
          </v-flex>
          <v-flex xs6 class="pl-3">
            <button
              type="button"
              class="faccess_button"
              @click="find_user_devices()"
              :disabled="searching_data == ''"
            >Consultar</button>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>
    <div class="" v-if="valid">
      <section class="access_devices__container table_card__head">
        <button
          type="button"
          class="faccess_button access_devices__button"
          @click="show_delete_validation = true"
        >Reestablecer Dispositivos</button>
        <div class="access_devices__header">
          <div class="access_devices__header--item">
            <span>No. Documento</span>
            <p>
              {{this.current_user.attributes.rut}}
            </p>
          </div>
          <div class="access_devices__header--item">
            <span>Email</span>
            <p>
              {{this.current_user.attributes.email}}
            </p>
          </div>
        </div>
        <section class="access_devices__devices">
          <div class="" v-if="user_devices.length > 0">
            <section class="access_devices__devices--header">
              <div class="access_devices__devices--item access_devices__header--item">
                <span>Tipo de dispositivo</span>
              </div>
              <div class="access_devices__devices--item access_devices__header--item">
                <span>Signature</span>
              </div>
              <div class="access_devices__devices--item access_devices__header--item">
                <span>Fecha Creación</span>
              </div>
            </section>
            <section
              class="access_devices__devices--header"
              v-for="device in user_devices"
              :key="device.id">
              <div class="access_devices__devices--item access_devices__header--item">
                <p>{{device.device_type}}</p>
              </div>
              <div class="access_devices__devices--item access_devices__header--item">
                <p>{{device.signature}}</p>
              </div>
              <div class="access_devices__devices--item access_devices__header--item">
                <p>{{$moment(device.created_at).format("YYYY/MM/DD HH:mm a")}}</p>
              </div>
            </section>
          </div>
          <div class="" v-else>
            <p>Este usuario no tiene dispositivos asociados</p>
          </div>
        </section>
      </section>
    </div>
    <section
      v-if="show_delete_validation"
      class="access_devices__modal">
      <section class="access_devices__modal--container">
        <p class="access_devices__modal--text">
          ¿Esta seguro que desea reestablecer los dispositivos de este usuario?
        </p>
        <div class="access_devices__modal--buttons">
          <div
            class="access_devices__modal--button active"
            @click="reset_devices()">
            Si
          </div>
          <div
            class="access_devices__modal--button"
            @click="show_delete_validation = false">
            Cancelar
          </div>
        </div>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      deleted_item: null,
      show_delete_validation: false,
      user_devices: [],
      current_user: {
        attributes:{
          email: '',
          rut:''
        }
      },
      searching_data: '',
      valid: false,
      user: {
        rut: '',
        email:'',
        company: this.getCompany().id
      }
    }
  },
  methods:{
    find_user_devices(){
      if(this.validate_data(this.searching_data)){
        console.log(this.searching_data);
        this.user.email = this.searching_data
      }else{
        console.log(this.searching_data);
        console.log(this.user);
        this.user.rut = this.searching_data
      }
      try {
        this.$http.get('app/users/find_user_devices', {
          headers: {
              "X-Device-ID" : this.getDeviceId(),
              // "Authorization" : 'Bearer ' + this.getUserToken()
          },
          params: this.user
        }).then(function(response){
          console.log(response);
          if(response.body != null){
            this.user_devices = []
            this.user_devices = response.body.meta.user_devices
            console.log(this.user_devices);
            this.current_user = response.body.data
            this.user.email = '',
            this.user.rut = ''
            console.log("<<<<<<<<<<<<<<<<Current User");
            console.log(this.current_user);
            this.valid = true
          }else{
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true);
          }
        }, function(response){
          console.log(response);
          this.user.rut = ''
          this.user.email = ''
          this.updateAlertMessage('No se ha encontrado el usuario con el documento o correo ingresado')
          this.updateIsInAlert(true);
        })
      } catch (e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true);
      }
    },
    validate_data(searching_data){
      let re = /\S+@\S+\.\S+/
      return re.test(searching_data)
    },
    reset_devices(){      
      try {
        this.$http.post('app/users/reset_user_devices',
          {
            id: this.current_user.id,
            company: this.current_user.attributes.company
          },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          },
        }).then(function(response){
          this.updateAlertMessage(response.body.ans)
          this.updateIsInAlert(true);
          this.valid = false;
          this.searching_data = ''
        }, function(response){
          console.log(response);
          this.updateAlertMessage('No se pudo procesar la petición')
          this.updateIsInAlert(true);
        })
      } catch (e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true);
      }
      this.show_delete_validation = false
    }
  },
  mounted(){
    console.log(this.user);
  },
  watch:{
    searching_data(){
      this.valid = false
    },
    show_delete_validation(){
      if(this.show_delete_validation == false){
        this.deleted_item = null
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/users/user_devices/ResetUserDevices.vue